import Query from "./query";

class GetTimeStamp extends Query {
    constructor() {
        super("getTimeStamp");
    }

    async execute(params) {
        return new Date();
    }
}

export default GetTimeStamp;